export const findValueInFrame = (frame, value) => {
  return frame.find((obj) => obj.value === value);
};
